import QuickTimeCard from 'src/components/QuickTime/QuickTimeCard/QuickTimeCard';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';

const mapStateToProps = (state: IStoreState) => ({
    quickTimes: state.QuickTimes.quickTimes,
    qtimeSlots: state.QuickTimes.qtimeSlots,
    // advisors: state.Specs.specs?.Advisors !== undefined ?
    advisors: state.Specs.deptSpecs?.Advisors !== undefined ?
        state.Specs.deptSpecs.Advisors : [],
    // state.Specs.specs?.Advisors : [],
    // trans: state.Specs.specs?.Transportation !== undefined ?
    trans: state.Specs.deptSpecs?.Transportation !== undefined ?
        state.Specs.deptSpecs.Transportation : [],
    // state.Specs.specs?.Transportation : [],
    specDeptData: state.Specs.deptSpecs !== undefined ? state.Specs.deptSpecs : BlankDeptSpec,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    specData: state.Specs.specs,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    appointment: state.Appointment,
});

export default connect(
    mapStateToProps,
    null,
)(QuickTimeCard);